import { render, staticRenderFns } from "./nbWater.vue?vue&type=template&id=61713636&"
import script from "./nbWater.vue?vue&type=script&lang=js&"
export * from "./nbWater.vue?vue&type=script&lang=js&"
import style0 from "./nbWater.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports